import { graphql } from "@/lib/gql/__generated__";

export const RoomStock_StockManagement_Query = graphql(/* GraphQL */ `
	query RoomStock_StockManagement($hotelID: ID!, $startDt: String!, $endDt: String!) {
		roomStock(hotelID: $hotelID, startDt: $startDt, endDt: $endDt) {
			id
			hotelID
			headers {
				date
				weekday
			}
			items {
				roomID
				name
				isInSale
				isDummyRoom
				stocks {
					date
					isAvailable
					remainNum
					isSetPrice
					isEditable
					soldNum
				}
			}
		}
	}
`);
